// extracted by mini-css-extract-plugin
export var cardHeader = "_fa-0";
export var reorderHandle = "_fa-3";
export var titleArea = "_fa-1";
export var titleAreaWithHandle = "_fa-2";